import { Monitor } from '../../platform/Monitor';
import { Component } from './Component';
import { ObjectManager } from './ObjectManager';
import { ParameterizedTriggerHook, SimpleTriggerHook, Trigger, TriggerHook } from './Trigger';
import { TriggerTree } from './TriggerTree';

// TODO: ChildAdded, ChildRemoved only fire for parent for now

export class TriggerCycle {

    private objects: ObjectManager;
    private triggers: TriggerTree;
    private affected: Set<Component> = new Set();
    private priorityDispatches = new Map<string, Set<Component>>();
    private regularDispatches = new Map<string, Set<Component>>();

    constructor(objects: ObjectManager, reactions: TriggerTree) {
        this.objects = objects;
        this.triggers = reactions;
    }

    public emit(hook: SimpleTriggerHook, idOrIds: string | string[]): void;
    public emit(hook: ParameterizedTriggerHook, idOrIds: string | string[], params: string[]): void;
    public emit(hook: any, idOrIds: string | string[], params?: string[]) {
        if (Array.isArray(idOrIds)) {
            for (const id of idOrIds) {
                this.emit(hook, id, params);
            }
        }
        else {
            const id = idOrIds;
            if (!!params) {
                for (const p of params) {
                    this.addDispatchFor(id, hook, p);
                }
            }
            else {
                this.addDispatchFor(id, hook, '*');
            }
        }
    }

    public run() {
        this.runDispatches(this.priorityDispatches);
        this.runDispatches(this.regularDispatches);
    }

    private addDispatchFor(subjectId: string, hook: TriggerHook, param: string) {
        const subject = this.objects.getMaybe(subjectId) || this.objects.getDead(subjectId);
        if (!subject) return;
        const hitsByType = this.triggers.query(subject.type, hook, param);
        for (const rn of hitsByType) {
            this.addDispatch(rn, subject);
        }
        const hitsByWildcard = this.triggers.query('*', hook, param);
        for (const rn of hitsByWildcard) {
            this.addDispatch(rn, subject);
        }
        this.affected.add(subject);
    }

    private addDispatch(tg: Trigger, subject: Component) {
        const store = tg.priority ? this.priorityDispatches : this.regularDispatches;
        const entry = store.get(tg.id) ?? (store.set(tg.id, new Set()).get(tg.id));
        entry.add(subject);
    }

    private runDispatches(store: Map<string, Set<Component>>) {
        // Prevent handlers being called twice or more
        const called = new Set<any>();
        for (const [id, cs] of store) {
            const tg = this.triggers.get(id);
            if (called.has(tg.handler)) continue;
            Monitor.logAction(`trigger: ${tg.id}`);
            tg.handler(this.cleanIfRequired(tg, cs));
            called.add(tg.handler);
        }
    }

    private cleanIfRequired(tg: Trigger, cs: Set<Component>) {
        // Unless specified, clean any dead components out
        const arr = [] as Component[];
        for (const c of cs) {
            if (tg.includeDead || c.alive) {
                arr.push(c);
            }
        }
        return arr;
    }

}
